<template>
</template>

<script>
  import SelectEdit from './SelectEdit.ts'
  export default SelectEdit
</script>
